import { BillEstimateOrderItemDto } from "@atlassian/cssxp-ccp-types";
import { PRODUCTION, getEnvironment } from "@atlassian/temp-shared";

type BillEstimate = {
  estimate: BillEstimateOrderItemDto;
  linkedEstimates: BillEstimateOrderItemDto[];
};

enum PromotionTypes {
  PARTNER_DISCOUNT = 'PARTNER_DISCOUNT',
  DISCRETIONARY_DISCOUNT = 'DISCRETIONARY_DISCOUNT',
}

export const getDiscretePromotionId = () => {
    if (getEnvironment() === PRODUCTION) {
      return '5eafb343-a085-489e-ad83-99abd608c918';
    } else {
      return '818c172b-cc56-4a24-a539-5e687d7173ef';
    }
  };

/**
 * A method which updates the response of the bill estimate to map the custom discretionary discount as partner discount
 * @param linkedEstimates
 */
export const updateAdjustmentsToPartnerDiscounts = (linkedEstimates: BillEstimate['linkedEstimates']) => {
    const promotionId = getDiscretePromotionId();
    linkedEstimates.forEach((linkedEstimate) =>
      linkedEstimate.items.forEach((item) => {
        if (item.adjustments) {
          item.adjustments.forEach((itemAdjustment: any) => {
            if (itemAdjustment.promotionId === promotionId) {
              itemAdjustment.reasonCode = 'partner.discount';
              itemAdjustment.type = PromotionTypes.PARTNER_DISCOUNT;
            }
          });
        }
      })
    );
  };